import React, { useCallback } from 'react';
import { useField } from 'formik';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import { VoiceOptionContent } from '@/components/voice-option-content';

import { useAgentVoiceQuery } from '@/query/agent.query';

export const Voices = React.memo(() => {
  const [field, meta, helpers] = useField<string>('voice_id');
  const { data } = useAgentVoiceQuery();
  const voices = data || [];
  const selectedVoice = voices.find(voice => voice.id.toString() === field.value?.toString());

  const onChange = useCallback((id: string) => helpers.setValue(id), [helpers.setValue]);

  return (
    <Card className="bg-muted rounded-2x gap-0 p-1 border-0">
      <CardHeader className="px-5 py-3">
        <div>
          <CardTitle className="text-sm font-medium mb-1">Available Voices</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="bg-card rounded-xl shadow-sm p-5">
        <Select onValueChange={onChange} value={field.value?.toString() || undefined}>
          <SelectTrigger
            className={`h-auto min-h-11 w-full py-2 ${meta.error && meta.touched ? 'border-red-500' : ''}`}
          >
            {selectedVoice ? (
              <VoiceOptionContent voice={selectedVoice} />
            ) : (
              <span className="text-sm text-muted-foreground">Select a voice</span>
            )}
          </SelectTrigger>
          <SelectContent className="max-h-80">
            {voices.map(voice => (
              <SelectItem key={voice.voice_id} value={voice.id.toString()} className="py-2">
                <VoiceOptionContent voice={voice} />
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {meta.error && meta.touched && <p className="text-sm text-red-500 mt-2">{meta.error}</p>}
      </CardContent>
    </Card>
  );
});
